<template>
  <div class=" move-in-from-top lang-switcher">
    <select :value="currentLang" @change="onLangChange" class="lang-select">
      <option value="uk">UA</option>
      <option value="en">EN</option>
    </select>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';
import {getSavedLanguage} from '@/i18n';

const store = useStore();
const currentLang = computed(() => getSavedLanguage());

function onLangChange(event) {
  const newLang = event.target.value;
  store.dispatch('ChangeLanguage', newLang);
}
</script>
<script>
export default {
  mounted() {
    function menushow(el) {
      el.classList.add('start')
    }

    setTimeout(menushow, 3000, this.$el);
  },

}
</script>
<style scoped>


.lang-switcher.start {
  font-weight: bold;
  display: flex;
  align-items: flex-end;
}

select {
  height: 30px;
}

</style>